import React from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

const DynamicPricingSettings = ({ settings, setSettings, updateSettings }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle style={{ fontSize: '1.25rem' }}>💰 Dynamic Pricing Rules</CardTitle>
      </CardHeader>
      <CardContent>
        <div style={{ display: 'grid', gap: '1.5rem' }}>
          <div>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
              <input
                type="checkbox"
                checked={settings.same_day_pickup_enabled || false}
                onChange={(e) => setSettings({...settings, same_day_pickup_enabled: e.target.checked})}
                style={{ width: '18px', height: '18px' }}
              />
              <span style={{ fontSize: '0.875rem', fontWeight: '600' }}>
                Enable Same-Day Pickup Surcharge
              </span>
            </label>
            
            {settings.same_day_pickup_enabled && (
              <div style={{ marginLeft: '1.75rem', marginTop: '0.5rem' }}>
                <label style={{ display: 'block', marginBottom: '0.25rem', fontSize: '0.875rem', color: '#6b7280' }}>
                  Surcharge Amount ($)
                </label>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <span style={{ fontSize: '1.25rem', fontWeight: '600' }}>$</span>
                  <input
                    type="number"
                    value={settings.same_day_surcharge || 0}
                    onChange={(e) => setSettings({...settings, same_day_surcharge: parseFloat(e.target.value) || 0})}
                    min="0"
                    step="1"
                    style={{
                      width: '120px',
                      padding: '0.5rem',
                      border: '1px solid #d1d5db',
                      borderRadius: '6px',
                      fontSize: '1rem',
                      fontWeight: '600'
                    }}
                  />
                </div>
                <p style={{ fontSize: '0.75rem', color: '#6b7280', marginTop: '0.25rem' }}>
                  Added to total when customer books same-day pickup
                </p>
              </div>
            )}
          </div>

          <div>
            <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.875rem', fontWeight: '600' }}>
              Weekend Pickup Surcharge (Saturday/Sunday)
            </label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <span style={{ fontSize: '1.25rem', fontWeight: '600' }}>$</span>
              <input
                type="number"
                value={settings.weekend_surcharge || 0}
                onChange={(e) => setSettings({...settings, weekend_surcharge: parseFloat(e.target.value) || 0})}
                min="0"
                step="1"
                style={{
                  width: '120px',
                  padding: '0.5rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '1rem',
                  fontWeight: '600'
                }}
              />
            </div>
            <p style={{ fontSize: '0.75rem', color: '#6b7280', marginTop: '0.25rem' }}>
              Additional charge for weekend pickups (set to $0 to disable)
            </p>
          </div>

          <div style={{ 
            padding: '1rem', 
            backgroundColor: '#f0fdf4', 
            borderRadius: '6px',
            border: '1px solid #10b981'
          }}>
            <h4 style={{ fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.5rem', color: '#065f46' }}>
              💡 Pricing Strategy Tips
            </h4>
            <ul style={{ fontSize: '0.75rem', color: '#065f46', marginLeft: '1.25rem', lineHeight: 1.6 }}>
              <li>Same-day surcharge encourages advance bookings</li>
              <li>Weekend pricing covers extra operational costs</li>
              <li>Customers see total price before payment</li>
            </ul>
          </div>

          <Button
            onClick={() => updateSettings(settings)}
            style={{
              backgroundColor: '#10b981',
              color: 'white',
              padding: '0.75rem 1.5rem',
              width: 'fit-content'
            }}
          >
            Save Pricing Rules
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default DynamicPricingSettings;
